import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

import { Headline as ContentHeadline } from "scmp-app/components/content/content-headline/styles";

export const CoverLink = styled.div`
  cursor: pointer;
  hover: {
    color: #ffffff;
  }
`;

export const CoverImage = styled.div`
  margin-block-end: 12px;

  border-radius: 4px;

  overflow: hidden;

  img {
    inline-size: 100%;

    border-radius: 4px;
  }
`;

export const Headline = styled.div`
  color: #ffffff;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontRobotoCondensed};
  line-height: 130%;
`;

export const HeadlineLink = styled.div`
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  &&&:hover {
    ${CoverLink}, ${HeadlineLink}, ${ContentHeadline} {
      color: #ffffff;
      text-decoration: underline;
    }
  }
`;
